export function setDateWithTime(
  date: Date,
  timeStr: string | null | undefined
): Date {
  // Check if timeStr is null or undefined
  if (!timeStr) {
    return date;
  }

  date = new Date(date);
  // Extract hours and minutes from timeStr
  const [hours, minutes] = timeStr.split(':').map(Number);

  // Set the hours and minutes on the date object
  date.setHours(hours, minutes);

  return date;
}
